<template>
  <div class="yuangongGuanLi">
    <div class="left_box">
      <div class="countNum" @click="allMemClick()">
        账号总数：
        <span>{{memCount}}</span>
      </div>
      <el-scrollbar style="height: 600px;overflow-x: hidden;overflow-y: auto">
        <ul class="account_data">
          <li v-for="(item, index) in dynamicTags" :key="index">
            <div class="renyuanliebiaoBox" @click="orgClick(item)">
              <div class="renyuanliebiao">{{item.name}}</div>
              ({{item.count}})
            </div>
          </li>
        </ul>
      </el-scrollbar>
    </div>

    <div class="right_box">
      <hdFilter
        @btnAction="btnAction"
        @searchAction="searchAction"
        ref="hdFilter"
        :btnList="btnList"
        placeholder="请输入用户名/手机号"
      ></hdFilter>
      <dataTable
        ref="dataTable"
        :flush="fresh"
        :inSerachFilte="inSerachFilte"
        :inTableData="tableDataConfig"
        :inAjax="tableAjaxConfig"
        :ispagination="true"
        @rowClick="tableClickConfig"
        rowKey="wxcode"
        @selection="selection"
      ></dataTable>
    </div>

    <connect ref="connect"></connect>

    <detailDialog ref="detailDialog" :queryObj="queryObj" :url="url" :method="method"></detailDialog>
  </div>
</template>

<script>
import bus from "../../components/commonComponents/bus";
import connect from "./components/connect";
import detailDialog from "../components/operationDetails";
import moment from "moment";
import GlobalUtil from "@/utils/globalUtil.js";

export default {
  components: {
    connect,
    detailDialog
  },
  data() {
    return {
      url: "",
      method: "",
      memCount: 0,
      queryObj: {},
      btnList: [
        {
          type: "add",
          name: "新增员工"
        },
        {
          type: "default",
          name: "设为默认名片"
        }
      ],
      icon: false,
      dynamicTags: [], // 组织列表
      //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
      fresh: "",
      // 用于匹配搜索数据，返回新的数据
      inSerachFilte: {
        queryObj: {}
      },
      //tableData组件参数配置
      tableDataConfig: {
        //表头及字段配置
        tHead: [
          {
            name: "姓名",
            field: "realName",
            type: "function",
            callback: function(v, row) {
              return `<i style="color:red;margin-right:5px;font-size:14px" class="${
                row.dftCard == 1 ? "el-icon-star-on" : ""
              }"></i>${v}`;
            }
          },
          {
            name: "性别",
            field: "sex",
            type: "function",
            callback: function(v, row) {
              let obj = {
                1: "<span>男</span>",
                2: "<span>女</span>"
              };
              return obj[v];
            }
          },
          {
            name: "微信号",
            field: "wxNumber"
          },
          {
            name: "手机号",
            field: "phone"
          },
          {
            name: "部门小组",
            field: "orgName"
          },
          {
            name: "加入时间",
            field: "createDate",
            type: "function",
            callback: function(v) {
              return `<span>${moment(v).format("YYYY-MM-DD")}</span>`;
            }
          },
          // {
          //   type: "function",
          //   field: "status",
          //   callback: function(v) {
          //     return `<span>${
          //       v == "0"
          //         ? '<span style="color:red">禁用</span>'
          //         : '<span style="color:#0094ff">启用</span>'
          //     }</span>`;
          //   },
          //   width: 40,
          //   click: true
          // },
          {
            name: "操作",
            type: "actionBtns", //配置操作按钮actionSelectBtns为下拉按钮，actionBtns为平铺按钮
            field: "sendDate",
            callback: function(v) {
              let arr = [
                {
                  type: "edit",
                  label: "编辑"
                },
                {
                  type: "status",
                  label: '<span style="color:red">启用</span>',
                  callback: function(v) {
                    return v.status === 1;
                  }
                },
                {
                  type: "status",
                  label: "禁用",
                  callback: function(v) {
                    return v.status === 0;
                  }
                },
                {
                  type: "action",
                  label: "交接",
                  callback: function(v) {
                    return v.status === 1;
                  }
                },
                {
                  type: "detail",
                  label: "操作详情"
                }
              ];
              return arr;
            }
          }
        ],
        //自动渲染
        tData: [],
        //自动渲染
        total: 0,
        actionBtWidth: "250",
        //配置是否显示多选框
        isMultiple: false,
        dispatchp: true,
        // 配置是否显示单选框
        isSingle: true,
        //配置是否显示排序
        isRank: true
      },
      tableAjaxConfig: {
        url: this.$url.userList,
        method: "post",
        data: {
          pageNumber: 1,
          pageSize: 15,
          queryObj: {}
        }
      },
      rowData: [], // 本行数据
      obj: {}
    };
  },
  created() {
    // 组织列表
    this.getList();
    this.getMemCount();
  },
  methods: {
    // 单选框选中事件
    selection(data) {
      this.rowData = data;
    },
    // 下拉框事件
    searchAction(e) {
      this.obj["nameOrPhone"] = e.value;
      this.inSerachFilte = { queryObj: this.obj };
    },
    orgClick(item) {
      this.obj["orgId"] = item.id;
      this.inSerachFilte = { queryObj: this.obj };
    },
    allMemClick() {
      this.obj["orgId"] = null;
      this.inSerachFilte = { queryObj: this.obj };
    },
    // hdFilter栏点击事件
    btnAction(data) {
      console.log(data);
      if (data === "add") {
        this.$router.push({
          name: "3dbussinessaddpeople",
          query: { data: data }
        });
      } else {
        // 设置默认名片
        if (this.rowData.length != "") {
          this.$axios
            .put(this.$url.modifyDftCard + "?id=" + this.rowData.rowData.id)
            .then(res => {
              console.log("我是默认名片", res);
              if (res.code == 0) {
                this.$message.success("设置成功！");
                // 刷新表单
                this.$refs.dataTable.templateRadio = "";
                this.$refs.dataTable.getList();
                this.rowData = "";
              }
            });
        } else {
          this.$message.error("请先选中!");
        }
      }
    },
    // 操作栏点击事件
    tableClickConfig(data) {
      console.log(data);
      if (data.type === "edit") {
        this.$router.push({
          name: "3dbussinessaddpeople"
        });
        GlobalUtil.setSessionStorage("rowData", data.rowData);
      } else if (data.type === "action") {
        this.$refs.connect.dialogTableVisible = true;
        this.$refs.connect.userInfo = data.rowData;
      } else if (data.type === "detail") {
        this.$refs.detailDialog.query(data.rowData, "YGGL");
      } else if (data.type === "status") {
        let use = data.rowData.status === 0 ? 1 : 0;
        let msg = "是否禁用该员工账号？";
        if (use === 0) {
          msg = "是否启用该员工账号？";
        }
        this.$confirm(msg, "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$axios
              .post(this.$url.updateStatus, {
                id: data.rowData.id,
                status: use
              })
              .then(res => {
                if (res.code == 0) {
                  this.$message.success("操作成功");
                  // 刷新表单
                  this.$refs.dataTable.getList();
                }
              });
          })
          .catch(() => {});
      }
    },
    getMemCount() {
      this.$axios.get(this.$url.getMemCount, {}).then(res => {
        this.memCount = res.data;
      });
    },
    // 获取部门人员数量列表
    getList() {
      this.$axios.get(this.$url.getPage, {}).then(res => {
        if (res.code == 0) {
          this.dynamicTags = res.data;
        }
      });
    }
  }
};
</script>

<style lang='less' scoped>
.yuangongGuanLi {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .left_box {
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-right: 1px solid #f5f5f5;
  }

  .right_box {
    height: 100%;
    width: 1354px;
    box-sizing: border-box;
    background-color: #fff;
    overflow-y: auto;
  }

  .countNum {
    height: 60px;
    padding-left: 16px;
    box-sizing: border-box;
    font-size: 16px;
    color: rgba(153, 153, 153, 1);
    line-height: 60px;
    border-bottom: 1px solid rgba(240, 242, 245, 1);

    span {
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }

  .account_data {
    width: 100%;
    overflow: hidden;
    padding: 16px;
    padding-left: 25px;
    box-sizing: border-box;

    li {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 6px;
      list-style: disc;
    }

    li:hover {
      cursor: pointer;
      color: #59cce1;
    }
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .renyuanliebiaoBox {
    display: flex;
    align-items: center;
  }

  .renyuanliebiao {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px;
    display: inline-block;
  }
}
</style>
